import './Loader.scss';

import i18n from 'Dictionaries/i18n';
import PropTypes from 'prop-types';
import React from 'react';

const Loader = ({ iconOnly, useContractText }) => {
	return (
		<div
			className='react__loader loading'
			data-icon-only={iconOnly}
			data-langauge={i18n.language}
			data-use-contract-text={useContractText}
		>
			<div className='bars'>
				<div className='loadingBar' />
				<div className='loadingBar' />
				<div className='loadingBar' />
				<div className='loadingBar' />
				<div className='loadingBar' />
			</div>
			<div className='text' />
		</div>
	);
};

Loader.propTypes = {
	useContractText: PropTypes.bool,
	iconOnly: PropTypes.bool
};

Loader.defaultProps = {
	useContractText: false,
	iconOnly: false
};

export default Loader;
